import * as m from "@paraglide/messages"
import type { SupportedLocale as Lang } from "@site-types/site"
import { CenteredMessagePage } from "./CenteredMessagePage"

export function ErrorPage({ locale }: { locale: Lang }) {
  return (
    <CenteredMessagePage
      className="page-error"
      title={m.error_404_label({}, { locale: locale })}
      linkHref="/"
      linkLabel={m.back_toHome({}, { locale: locale })}
    >
      <p>{m.error_404_description({}, { locale: locale })}</p>
    </CenteredMessagePage>
  )
}
